// Copyright (c) 2017, Shellyl_N and Authors
// license: ISC
// https://github.com/shellyln
/**
 *
 */
export class ArrayPolynomialRing {
    /**
     *
     */
    constructor(field) {
        this.field = field;
        this._zero = [field.ZERO];
        this._one = [field.ONE];
        this._nan = [field.NaN];
    }
    /**
     *
     */
    listPx(nth) {
        throw new Error("not supported operation");
    }
    getAt(x, index) {
        return x[index];
    }
    setAt(x, index, v) {
        x[index] = v;
        return x;
    }
    slice(x, start, end) {
        return x.slice(start, end);
    }
    map(x, fn) {
        return this.mapToSelf(Array.from(x), fn);
    }
    mapToSelf(x, fn) {
        for (let i = 0; i < x.length; i++)
            x[i] = fn(x[i]);
        return x;
    }
    newNthPolynomial(n) {
        const r = [];
        r.length = n + 1;
        r.fill(this.field.ZERO);
        return r;
    }
    /**
     *
     */
    get ZERO() {
        return Array.from(this._zero);
    }
    /**
     *
     */
    get ONE() {
        return Array.from(this._one);
    }
    /**
     *
     */
    get NaN() {
        return this._nan;
    }
    /**
     *
     */
    normalize(x) {
        return (Array.isArray(x) ? x : Array.from(x)).map(v => this.field.normalize(v));
    }
    /**
     *
     */
    isNaN(x) {
        if (x !== this.NaN) {
            if (x.length === 1 && x[0] === this.field.NaN)
                return true;
            return false;
        }
        return true;
    }
    /**
     *
     */
    eq(x, y) {
        if (this.isNaN(x) || this.isNaN(y))
            return false;
        const zero = this.field.ZERO;
        const len = Math.max(x.length, y.length);
        for (let i = 0; i < len; i++) {
            if (!this.field.eq(x[i] !== void (0) ? x[i] : zero, y[i] !== void (0) ? y[i] : zero))
                return false;
        }
        return true;
    }
    /**
     *
     */
    noteq(x, y) {
        return !this.eq(x, y);
    }
    /**
     *
     */
    neg(x) {
        const r = [];
        for (let i = 0; i < x.length; i++) {
            r[i] = this.field.neg(x[i]);
        }
        return r;
    }
    /**
     *
     */
    add(x, y) {
        const r = [];
        const zero = this.field.ZERO;
        r.length = Math.max(x.length, y.length);
        for (let i = 0; i < r.length; i++) {
            r[i] = this.field.add(x[i] !== void (0) ? x[i] : zero, y[i] !== void (0) ? y[i] : zero);
        }
        return r;
    }
    /**
     *
     */
    sub(x, y) {
        const r = [];
        const zero = this.field.ZERO;
        r.length = Math.max(x.length, y.length);
        for (let i = 0; i < r.length; i++) {
            r[i] = this.field.sub(x[i] !== void (0) ? x[i] : zero, y[i] !== void (0) ? y[i] : zero);
        }
        return r;
    }
    /**
     *
     */
    mul(x, y) {
        const r = [];
        const zero = this.field.ZERO;
        r.length = x.length + y.length - 1;
        for (let i = 0; i < r.length; i++) {
            r[i] = zero;
        }
        for (let i = 0; i < y.length; i++) {
            for (let j = 0; j < x.length; j++) {
                r[j + i] = this.field.add(r[j + i], this.field.mul(x[j], y[i]));
            }
        }
        return r;
    }
    /**
     *
     */
    mod(x, y, extendDividendLength = 0) {
        return this.divmod(x, y, extendDividendLength).r;
    }
    /**
     *
     */
    divmod(x, y, extendDividendLength = 0) {
        x = Array.from(x);
        const zero = this.field.ZERO;
        if (extendDividendLength > 0) {
            const ext = [];
            ext.length = extendDividendLength;
            for (let i = 0; i < extendDividendLength; i++) {
                ext[i] = zero;
            }
            x = ext.concat(x);
        }
        let ylen = y.length;
        for (let i = 0; i < ylen; i++, ylen--) {
            if (y[ylen - 1] !== void (0) &&
                this.field.noteq(y[ylen - 1], zero))
                break;
        }
        if (ylen === 0)
            return { q: this.NaN, r: this.NaN, divisible: false };
        const n = x.length - ylen + 1;
        const q = [];
        q.length = n;
        for (let i = 0; i < n; i++) {
            if (this.field.noteq(x[x.length - 1 - i], zero)) {
                const c = this.field.divmod(x[x.length - 1 - i], y[ylen - 1]);
                q[n - 1 - i] = c.q;
                for (let j = 0; j < ylen - 1; j++) {
                    x[n - 1 - i + j] = this.field.sub(x[n - 1 - i + j], this.field.mul(y[j], c.q));
                }
                x[x.length - 1 - i] = c.r;
            }
            else {
                x[x.length - 1 - i] = zero;
            }
        }
        let divisible = true;
        const r = [];
        r.length = ylen - 1;
        for (let i = 0; i < r.length; i++) {
            if (x[i])
                divisible = false;
            r[i] = x[i];
        }
        return { q, r, divisible };
    }
    /**
     *
     */
    pow(a, x) {
        throw new Error("not supported operation");
    }
    /**
     *
     */
    exp(x) {
        throw new Error("not supported operation");
    }
}
/**
 *
 */
export class NumberArrayPolynomialRing extends ArrayPolynomialRing {
}
//# sourceMappingURL=ArrayPolynomialRing.js.map